<template>
  <div class="quality quality-submit">
    <z-form label-width="100px" @submit="onSubmit" @failed="onFailed">
      <z-field
        v-model="bizName"
        name="bizName"
        label="企业名称"
        label-width="100px"
        placeholder="请输入认证企业名称"
        readonly
      />

      <z-field
        v-model="creditCode"
        name="creditCode"
        label="社会信用代码"
        label-width="100px"
        placeholder="请输入认证社会信用代码"
        readonly
      />

      <z-field
        readonly
        clickable
        name="permitType"
        :value="permitTypeValue"
        label="许可证类型"
        placeholder="点击选择许可证类型"
        label-width="100px"
      />
      <!-- <z-popup v-model="showPicker" position="bottom">
        <z-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </z-popup> -->

      <z-field
        v-model="permitCode"
        name="permitCode"
        label="许可证编号"
        label-width="100px"
        placeholder="请输入许可证编号"
      />

      <!-- <section class="quality-evidence">
        <capture-upload
          @uploaded="UploadedEvi"
          type="evidence"
          img="e549152d-2a15-472c-89e5-074007567d9b.png"
        />
      </section> -->

      <section class="upload-area">
        <evidence-upload-item class="evidence" type="front" tip="点击上传彩色原件或加盖公司公章的复印件" @uploaded="UploadedEvi">
          <div class="sample-cover"></div>
        </evidence-upload-item>
      </section>

      <z-button-group>
       <z-button type="primary" btn-class="bottombtn" native-type="submit" :disabled="disabled" >下一步</z-button>
      </z-button-group>
    </z-form>
  </div>
</template>

<script>
import { Field, Button, ButtonGroup, Toast, Form } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
// import CaptureUpload from '../../PayMoney/Submit/CaptureUpload/CaptureUpload'
// import MediaUploadItem from '../../RealAuth/MediaUploadItem/MediaUploadItem';
import EvidenceUploadItem from '../../../cloudInspection/MediaUploadItem/MediaUploadItem';
import { checkAuditStatusNew, getbizpermittype, submitAuditInfoNew } from '../../../../api/resourceApi'
import { getCookie } from '../../../../lib/utils'

export default {
  name: 'QualityPermit',
  data() {
    return {
      bizName: '', //企业名称
      creditCode: '', //统一社会信用代码
      columnsObj: {},
      permitType: this.$rootEle.permitType, //许可证类型
      permitCode: '', //许可证编码
      permitPic: '', //许可证图片
      showPicker: false,
      permitStatus: '',
      quaStatus: '',
      quaProofId: '',
      proofList: ''
    }
  },
  inject: ['$rootEle'],
  computed: {
    disabled() {
      return (
        this.permitCode === '' ||
          this.permitPic === ''
      )
    },
    permitTypeValue() {
      return this.columnsObj[this.permitType]
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zField: Field,
    zForm: Form,
    EvidenceUploadItem
  },
  methods: {
    async getDetial() {
      const { bizName, quaStatus, quaProofList, quaProofId, creditCode, permitStatus, permitCode } = await checkAuditStatusNew(
        {
          infoId: this.$rootEle.infoId,
          permitType: this.$rootEle.permitType,
          productQuaType: this.$rootEle.productQuaType
        }
      );
      this.bizName = bizName;
      this.creditCode = creditCode;
      this.permitStatus = permitStatus
      this.permitCode = permitCode
      this.quaStatus = quaStatus
      this.quaProofId = quaProofId
      this.proofList = quaProofList
      if (permitStatus == '0') {
        this.$rootEle.setResultStatus('process')
        this.$rootEle.stateChange('permit', 'result', 3)
      }
      if (permitStatus == '1') {
        this.$rootEle.stateChange('permit', 'otherquality', 2)
      }
    },
    async getTypeList() {
      const { list = [] } = await getbizpermittype();
      this.columnsObj = list.reduce((cur, per) => {
        const { label, value } = per;
        cur[value] = label
        return cur
      }, {});
    },
    onConfirm(permitType) {
      this.permitType = permitType;
      this.showPicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
      Toast('failed');
    },
    UploadedEvi(rst) {
      this.permitPic = rst
    },
    async onSubmit(values) {
      console.log('submit', values);
      const { permitCode } = values;
      const params = {
        permitCode,
        permitPic: this.permitPic,
        permitType: this.$rootEle.permitType,
        sourceCode: this.$rootEle.sourceCode,
        permitStatus: this.permitStatus
      }
      if (this.disabled) return Toast('请填写所有内容再提交')
      if (['0', '-1', '1'].includes(String(this.quaStatus))) {
        await submitAuditInfoNew({
          reqUid: getCookie('uid'),
          proofList: this.proofList,
          infoId: this.$rootEle.infoId,
          sourceCode: this.$rootEle.sourceCode,
          reasonId: this.$rootEle.reasonId - 0,
          quaProofId: this.quaProofId,
          quaType: this.$rootEle.productQuaType,
          permitStatus: this.permitStatus,
          ...params
        })
        this.$rootEle.setResultStatus('deal')
        this.$rootEle.stateChange('permit', 'result', 3)
      } else {
        this.$rootEle.setSubmitData('permit', params)
        this.$rootEle.stateChange('permit', 'otherquality', 2)
      }
    }
  },
  mounted() {
    this.getDetial();
    this.getTypeList();
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
